import { Component, OnInit, ElementRef, ViewChild, NgZone, AfterViewChecked, PLATFORM_ID, Inject, AfterViewInit } from '@angular/core';
import { NetworkServicesService } from 'src/app/networkCalls/network-services.service';
import { Title, Meta } from '@angular/platform-browser';
import { katanaInput } from 'src/app/models/katana-input.service';
import { katanaResult } from 'src/app/models/katana-result.service';
import { CKEditorComponent } from 'ngx-ckeditor';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Observable, from } from 'rxjs'; 
// import { MatDialog } from '@angular/material';
// import { ErrorModalComponent } from '../error-modal/error-modal.component';
// import { ProgressStatusService } from '../../services/progress-status-service'
import { rejectError } from 'src/app/models/reject-suggetions.service';
// import { NGXLogger } from 'ngx-logger';
import { acceptError } from 'src/app/models/accept-suggetions.service';
import { trigger, transition, style } from '@angular/animations';
// import { $ } from 'protractor';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
import { MatRadioChange } from '@angular/material/radio';
import { environment } from 'src/environments/environment';
import { EnglishGrammarCheckerComponent } from 'src/app/Components/english-grammar-checker/english-grammar-checker.component'
import { DetectionLimitExhaustModalComponent } from '../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { FeedbackModalComponent } from 'src/app/Components/feedback-modal/feedback-modal.component';
//import { start } from 'repl';
declare function ire(string,{}): any;
@Component({
  selector: 'app-gc-editor',
  templateUrl: './gc-editor.component.html',
  styleUrls: ['./gc-editor.component.scss']
})
export class GcEditorComponent implements OnInit, AfterViewInit, AfterViewChecked {
  

  public minLength = 0;
  public maxLength = 300;
  ukey = "";
  languageSelection = "us";
  public alertErrorMessage = "TRUE";
  initialHighlightTag = "<span style='background-color:pink !important'>";
  initialHighlightCloseTag = "</span>";
  focusHighlightTag = "<span style='background-color:yellow !important'>";
  focusHighlightTagClosTag = "</span>";

  spellingErrorStartHeighlight = "<span style='border-bottom:solid #fd9a00;'>";
  spellingErrorEndHeighlight = "</span>";
  spellingErrorHeighlightActive = "<span style='border-bottom: solid #fd9a00; background-color: #fd9a005e;'>";

  grammarErrorStartHeighlight = "<span style='border-bottom:solid #7a6ff1;'>";
  grammarErrorEndHeighlight = "</span>";
  grammarErrorHeighlightActive = "<span style='border-bottom: solid #7a6ff1; background-color: #7a6ff152'>";

  advisorErrorStartHeighlight = "<span style='border-bottom:solid #37c5ab;'>";
  advisorErrorEndHeighlight = "</span>";
  advisorErrorHeighlightActive = "<span style='border-bottom: solid #37c5ab; background-color: #37c5ab5c;'>";
  errorProgressCount = 0;
  showPopup : boolean = false;

  enableCheck = true;
  public noeErrorFound = false;
  public planText = "";
  public wordCount: number = 0;
  public errorMessage = "";
  _timeout: any = null;
  editorValue = "";
  emailAdress = "";
  emailAdressFlag = false;
  emailDirty = false;
  panelOpenState = false;
  katanaResHold = [];
  katanaOrigResHold = [];

  prevElementHolder = null;
  gec_result = [];
  katanaResult: any;
  ip_address: any;
  showloader:boolean=false;
  tagNames = ["grammarly-popups", "grammarly-card", "grammarly-extension", "grammarly-btn"]

  timmer:number = 0; 
  isCTAClicked: boolean = false;
  isProcessStarted: boolean = false;
  showExhaustLimitModal: boolean = false;
  timer;


  @ViewChild(CKEditorComponent, { static: false }) ckEditor: CKEditorComponent;
  @ViewChild("sampleEditor", {static:false}) sampleEditor:any;

  constructor(
    private networkServices: NetworkServicesService,
    private elRef: ElementRef,
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    private _snackBar: MatSnackBar,
    private _dialog: MatDialog,
    // public dialog: MatDialog,
    // public progressStatusService: ProgressStatusService,
    // private errorModalComponent: ErrorModalComponent,
    public lc: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object
    // private logger: NGXLogger,
  ) {
    window.addEventListener("message", (d)=>{this.listenWindowMessage(d)});
  }


  config = {
    allowedContent: true,
    forcePasteAsPlainText: true,
    disallowedContent: 'img a strong',
    // removeButtons: 'Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript',
    removeDialogTabs: 'link:advanced',
    toolbar: [],
    height: 380,
    width: "auto",
    contentsCss: ["body{font-size: 16px;font-family: 'Open Sans', sans-serif;line-height: 22px;}"],
    removePlugins: 'pastefromword,elementspath,link,resize,iframe,contextmenu,liststyle,tabletools,tabletools,tableselection',
    stylesSet: "/src/styles.css",
    extraAllowedContent: 'span(*)[*]{*}',
    // extraPlugins:'confighelper',
    placeholder: 'Type here...'
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {

      let ele = document.getElementsByClassName("loader")[0] as HTMLElement;
      ele.style.display = "none"
      if (this.editorValue) {
        this.alertErrorMessage = "TRUE"
      }
      this.getUkeyrequest();
      $("#closedExceededPopup, #FooterClosedExceededPopup").click(function (){
        $("#usageLimitExhausted").removeClass('show');
      });
      $("#closedAcceptedLimitExhaustedPopup").click(function (){
        $("#acceptedLimitExhausted").removeClass('show');
      })
    }
    // ele.classList.remove("loading")
    this.titleService.setTitle("Verificador gramatical online gratuito Trinka");
    this.metaTagService.updateTag({ name: 'description', content: "O verificador gramatical online gratuito ajuda você a corrigir instantaneamente os seus erros de escrita, gramática, ortografia e muito mais." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Verificador gramatical online gratuito Trinka" });
    this.metaTagService.updateTag({ property: 'og:description', content: "O verificador gramatical online gratuito ajuda você a corrigir instantaneamente os seus erros de escrita, gramática, ortografia e muito mais." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/pt/grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/pt/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pt/grammar-checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'pt-pt' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/corrector-gramatical' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/grammar-checker' });
    //this.LinkService.addTag({ rel: 'alternate', hreflang: 'de-de', href: 'https://www.trinka.ai/de/grammatik-pruefen' });
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/wisepop.js', function () { });
      $.getScript('../../../assets/js/browser.js', function () { });
    }
    if (isPlatformBrowser(this.platformId)) {
      setInterval(() => {
        let errorElements = Array.from(document.getElementsByTagName('trinka-extension'));
        errorElements.forEach((singleElement) => {
          const shadowRoot = singleElement.shadowRoot;
          if(shadowRoot.querySelector('.ErrorContainers.l'))shadowRoot.querySelector('.ErrorContainers.l').remove();
        });
        const grammarlyDiv = Array.from(document.getElementsByTagName('grammarly-mirror'));
        grammarlyDiv.forEach((grammarlyMainDiv) => {
          grammarlyMainDiv.remove();
        })
      }, 5000);
     
    }
    ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
  }

  ngAfterViewChecked() {
    if (isPlatformBrowser(this.platformId)) {

      this.onFocus();
    }
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
      $("#GCChromeButton").css("display", "none");
      $("#GCFirFoxButton").css("display", "none");
      $("#GCEdgeButton").css("display", "none");
      return 'Opera';

    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      $("#GCChromeButton").css("display", "block");
      $("#GCFirFoxButton").css("display", "none");
      $("#GCEdgeButton").css("display", "none");
      return 'Chrome';

    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      $("#GCChromeButton").css("display", "none");
      $("#GCFirFoxButton").css("display", "none");
      $("#GCEdgeButton").css("display", "none");
      
      return 'Safari';

    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      $("#GCChromeButton").css("display", "none");
      $("#GCFirFoxButton").css("display", "block");
      $("#GCEdgeButton").css("display", "none");
      return 'Firefox';

    }
    else if ((navigator.userAgent.indexOf("MSIE") != -1)) {
      $("#GCChromeButton").css("display", "none");
      $("#GCFirFoxButton").css("display", "none");
      $("#GCEdgeButton").css("display", "block");
      return 'IE';
    }
    else {
      return 'unknown';
    }
  }


  getUkeyrequest() {
    this.networkServices.initApiwhichGetuKey().subscribe(result => {
      if (result['status'] == true) {
        this.ukey = result['ukey']
      } else {
        this.ukey = "";
      }
    })
  }

  rejectSuggetionsRequest(obj: rejectError) {
    obj['ukey'] = this.ukey
    this.networkServices.rejectSuggetionsApi(obj).subscribe(result => {
      if (result['status'] == true) {
      } else {
      }
    })
  }

  acceptSuggetionsRequest(obj: acceptError) {
    obj['ukey'] = this.ukey
    this.networkServices.acceptSuggetionsApi(obj).subscribe(result => {
      if (result['status'] == true) {
      } else {
      }
    })
  }

  languageTypeSelect(lang) {
    this.languageSelection = lang;
    this.postMessage("config")
  }

  // openDialog(errormsg) {
  //   this.errorMessage = errormsg;
  //   // this.errorMssgPass.errormsgObj = errormsg;
  //   this.errorModalComponent.setErrorMessage(errormsg);
  //   const dialogRef = this.dialog.open(ErrorModalComponent);
  //   dialogRef.afterClosed().subscribe(result => {
  //     // this.logger.debug(`Dialog result: ${result}`);
  //   });
  // }

  progressStatus(flag) {
    // this.progressStatusService.progressStatus(flag)
    this.enableCheck = flag;
  }

  injectErrorClass(item) {
    if (isPlatformBrowser(this.platformId)) {
      if (item.error_type[0] == 1) {
        return "grammar";
      } else if (item.error_type[0] == 2) {
        return "spelling"
      } else {
        return "suggestion"
      }
    }
  }

  public onChange(event) {
    this.enableCheck = false;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        try {
  
          // this.ckEditor.instance.on("key", this.onKeyUp, this)
          setTimeout(() => {
            debugger;
            // this.sampleEditor.nativeElement.value = this.sampleEditor.nativeElement.value + event.clipboardData.getData("text");
            if(this.isCTAClicked) {
              this.wordCountLogic(2);
              this.postMessage('restart');
            }
            else this.wordCount = event.target.value.split(' ')[0] !== '' ? event.target.value.split(' ').length : 0;
          }, 1);
          
         
          // if (this.planText.trim() == "") {
          //   this.gec_result = [];
          //   this.katanaResult = [];
          //   this.katanaResHold = [];
          //   this.katanaOrigResHold = [];
          //   this.ckEditor.instance.document.getBody().$.innerHTML = "";
          // }
  
        } catch (error) {
          console.log(error);
          // this.logger.debug(error)
        }
      }
  }, 2000)
   
  }

  public onClick() {
    console.log("editor click")
  }

  wordCountLogic(engineStatus) {
    if (isPlatformBrowser(this.platformId)) {
        // let edt = this.ckEditor.instance;
        // this.planText = this.ckEditor.instance.document.getBody().$.innerHTML.replace(/<\/p>/gi, "\n")
        this.planText = this.sampleEditor.nativeElement.value.replace(/<\/p>/gi, "\n")
          .replace(/<br\/?>/gi, "\n")
          .replace(/<\/?[^>]+(>|$)/g, "")
          .replace(/&nbsp;/g, " ")
          this.enableCheck = false;
          this.wordCount;
        let splitedList = this.planText.trim().split(/ |\n/g);
        if (splitedList[0] == "\n") {
          splitedList.splice(0, 1)
        }

        for (let index = 0; index < splitedList.length; index++) {
          if (splitedList[index] == "") {
            splitedList.splice(index, 1)
            index -= 1;
          }
        }

        this.wordCount = splitedList.length;
        if (this.wordCount >= this.maxLength || this.wordCount <= this.minLength) {
          if(this.wordCount > 0) { 
            $("#usageLimitExhausted").addClass('show');
            this.postMessage("stop");
          }
        }else if(engineStatus == 0){
          this.showExhaustLimitModal = true;
          this.postMessage("start");
        }else if(engineStatus == 1){
          this.showExhaustLimitModal = true;
          this.postMessage("restart");
        } else if(engineStatus === 3) {
          if(this.showExhaustLimitModal) $("#acceptedLimitExhausted").addClass('show');
          this.showExhaustLimitModal = false;
        }
    }
  }

  listenWindowMessage(d){
    if(d.data.target == "trinka"){
      let type = d.data.data.action;
      switch(type){
        case "login":
          console.log("login is called");
          this.wordCountLogic(2)
          break;
        case "accept":
          this.wordCountLogic(2)
          break;
        case "showLoader":
          this.showLoaderBadge()
          break;
        case "showLoginScreen":
          this.wordCountLogic(3);
          break;  
      }
    }
  }

  showLoaderBadge(){
      // implement debouncing in this functionality for show loader 
      // showloader = false default
      let timer;
      this.showloader = true;
      clearTimeout(timer)
      timer = setTimeout(()=>{
        this.showloader = false;
        this.isProcessStarted = false;
      },3000);
  }
  postMessage(type){
    parent.postMessage({
      "target": "content",
      "action": "client_action",
      "data": {
        "action": type,
        "userId": "demo@trinka.ai",
      }
    },"https://www.trinka.ai/pt/")
  }
  
  /* This function call when user click on Check button*/
  onGrammarCheck(event) {
    if (isPlatformBrowser(this.platformId)) {
      console.log("grammer check called")
      if (!this.isCTAClicked) this.wordCountLogic(0);
      else this.wordCountLogic(1);
      this.isCTAClicked = true;
      this.isProcessStarted = true;
    
      // if (this.ukey == "") { 
      //   this.getUkeyrequest();
      // }
      // if (this.ckEditor.instance.document.getBody().$.innerHTML.replace(/<p>|<\/p>|<br>/g, "")) {
      //   this.emailDirty = false;
      //   // let edt = this.ckEditor.instance;
      //   this.prevElementHolder = null;
      //   // this.planText = edt.document.getBody().getText()
      //   this.planText = this.sampleEditor.nativeElement.value;
      //   let text = this.planText.trim()
      //   if (text.split(" ").length <= this.maxLength && text.split(" ").length >= this.minLength) {
      //     this.ckEditor.instance.document.getBody().$.innerHTML = this.ckEditor.instance.document.getBody().$.innerHTML.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/(<!--{cke_protected})([^<>]*)(-->)/g, "")
      //     // this.logger.debug(this.ckEditor.instance.document.getBody().$.innerHTML.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/(<!--{cke_protected})([^<>]*)(-->)/g, ""))
      //       // if (this.validateEmail(this.emailAdress)) {
      //       // this.emailAdressFlag = true;
      //       // debugger
      //       // this.alertErrorMessage = "TRUE"
      //       this.clearAllHighlight()
      //       this.gec_result = [];
      //       this.katanaResHold = [];
      //       this.katanaResult = [];
      //       this.katanaOrigResHold = [];
      //       this.progressStatus(true)
      //       this.ckEditor.instance.document.getBody().$.innerHTML = this.ckEditor.instance.document.getBody().$.innerHTML.replace(new RegExp("<\/p><p>", 'g'), "<\/p><p> ")
      //       this.sendTextToKatana({
      //         'text': this.htmlEntitiesReplacer(this.ckEditor.instance.document.getBody().$.innerHTML),
      //         // .replace("&rsquo;","'")
      //         // // .replace(/<\/p>/g,"\n\n")
      //         // // .replace(/<p>/g,"\n\n")
      //         // .replace(/&lt;/g,"<")
      //         // .replace(/&gt;/g,">")
      //         // .replace(/&nbsp;/g," "),
      //         'subsuperscript': false
      //       })


      //     // } else {
      //     //   alert("Please enter valid email address.")
      //     //   this.emailAdressFlag = false;
      //     // }

          
      //   } else {
      //     // alert(`Oh oh! Please reduce the number of words to ${this.maxLength}.`)
      //     $("#usageLimitExhausted").addClass('show');
      //     // document.getElementById("usageLimitExhausted").classList.add('modal ');
      //     // $("#usageLimitExhausted").modal('show');
      //   }
      // } else {
      //   alert("Please enter text")

      // }
    }
  }
  
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $("#closedExceededPopup").click(function (){
        $("#usageLimitExhausted").removeClass('show');
      })
      $("#closedAcceptedLimitExhaustedPopup").click(function (){
        $("#acceptedLimitExhausted").removeClass('show');
      })

      this.wordCount = 0;
      // setTimeout(() => {
      //   let edt = this.ckEditor.instance;
      //   this.wordCountLogic();
      //   // this.logger.debug(this.wordCount)

      //   var isCtrl = false;
      //   edt.on('contentDom', function (evt) {
      //     edt.document.on('keyup', function (event) {
      //       if (event.data.$.keyCode == 17) isCtrl = false;
      //     }, this);

      //     edt.document.on('keydown', function (event) {
      //       if (event.data.$.keyCode == 17) isCtrl = true;
      //       if (event.data.$.keyCode == 83 && isCtrl == true) {
      //         //The preventDefault() call prevents the browser's save popup to appear.
      //         //The try statement fixes a weird IE error.


      //         try {
      //           event.data.$.preventDefault();
      //         } catch (err) { }

      //         //Call to your save function

      //         return false;
      //       }
      //     }, this);

      //   }, edt.element.$);
      // }, 2000);
    }
  }
  sampleData = [
    { 'key': "General", 'text': "The article was written on 1984. It was about this experiments that were carried out on some isolated village. The villages (Lulbushki) was located in a mountaineous region and well built yak roamed the pastures. The inhabitants in Lulbushki have been dependent of the pastures. On 25st of Nvember 1984, some of the yak were rounded up in accordance to the new animal husbandry law of Peking and informations on the compensatory measures was announced. The yak were coloured white to distinguished them but it was hard to make out teh difference. They were terrified and could have possibly undergone trauma. The yak like to roam freely in nature and do grazing in pastures with their herdsmen guarding them. The herdsmen understand a value of a yak however, they may end up to sell them." },
    { 'key': "Medicine", 'text': "Pre-treatment using antibiotic is said to affect clinical features of meningitis. That is why it is stated that LP should been carried out in childrens experiencing fever and seizures who have received antibiotic. As it has been found in a recent study. CSF becomes sterile for meningococccal and pneumococcal bacteria between 2 to 4 hours of administrating third-generation cephalosporin antibiotics. A lot of studies have been done on efficacy of lumbar puncture in febrile convulsion patients. Futhermore retrospective cohort reviews for children age 7 month to 6 year in 2011 found that probability for bacterial meningitis first presenting as an simple febrile seizure is very low. And they recommend that teh current PMC guidelines should be reconsidered. Hence, this observational , cross sectional, hospital-based study was carried out in Hemon Clinic, Samoa, during the period from June 15, 2019 and 28 November 2019. Fifty five children aged 7 month to 6 years who presented with fever and convulsion underwent lubmar puncture." },
    { 'key': "Management", 'text': "At the time of the period of the study, the dummy variables representing personal and workplace characters reached to different values. Although both genders experienced increase in the number of jobs involving the management and supervision of other employee, but this increase was greater for men. This finding may due to firms retaining workers whom are more integrted with in the structure of the company. These worker would be able to do more tasks needing higher level of responsibility then those who had joined the company more recent. Regarding types of contract there was no significant change into the mean percentage of full-time contracts, in spite of the fact that it remains less common for women to get this types of contract. Never the less there was a average increase of 10 percentage points in indefinite hiring for women, which is suggesting that there was increased job stabilization for qualified white collar women with average values approaching those for men." },
    { 'key': "Psychology", 'text': "Depression is most common mental disorder among HIV/AIDS patients with prevalence rates of about 60 %. Studies found that HIV patients had twice the risk for depression than those who were at risk for HIV. Depression and HIV/AIDS are estimated become the world’s leading causes of disability by 2030 [4-6]. Low- and middle-income countries are bearing the high burden of depression among HIV/AIDS patients. The symptoms of depressive disorders decrease adherence to HIV antiretroviral therapy leading to drug resistant virus [7]. Decreased social support with in the context of HIV/AIDS is related to increase depression because of various factor, like educational disability and food insecurity. Low social support could result in poor adherence of medication, leads to immune suppression which finally leads to depression. Furhtermore, poor social support may lead to social isolation, which can be responsible in depression. Social isolation by HIV patients reduces social support that can results in a negative impcat on their physical and mental well being."},
  ]
  addSampleData(event: MatRadioChange) {
    let data = this.sampleData.filter(obj => { return obj.key == event.value })
    let content = data[0].text;
    // this.ckEditor.instance.document.getBody().$.innerHTML = content;
    this.sampleEditor.nativeElement.value = content;
    this.enableCheck = false;
    if (this.isCTAClicked) this.wordCountLogic(1);
    else this.wordCount = content.split(' ').length;
    
  }

  addDummyText() {
    if (isPlatformBrowser(this.platformId)) {

      // debugger
      this.alertErrorMessage = "TRUE"
      this.clearAllHighlight()
      this.gec_result = [];
      this.katanaResHold = [];
      this.katanaResult = [];
      this.katanaOrigResHold = [];
      this.ckEditor.instance.document.getBody().$.innerHTML = "The article was written on 1984. It was about this experiments that were carried out on some isolated village. The villages (Lulbushki) was located in a mountaineous region and well built yak roamed the pastures. The inhabitants in Lulbushki depended of the pastures. On 25st of Nvember 1984, some of the yak were rounded up in accordance to the new animal husbandry law of Peking and informations about what would be done was announced. The yak were coloured white to distinguished them but it was hard to make out teh difference. They were terrified and could possibly have undergone trauma. The yak like to roam freely in nature and do grazing in pastures with their herdsmen guarding them. The herdsmen understand how valuable theur yak are to they. However, they may end up to sell them.\n";
      // this.wordCountLogic();
    }
  }
  // This function send text to katana for segment the sentences.
  sendTextToKatana(data: katanaInput) {
    this.networkServices.postRequestForKatana(data).subscribe(result => {
      if (result['success']) {
        this.katanaResult = result['result'];

        // const regex = /<\/[a-z]+>|<[a-z]+>|<\/[a-z] >|<[a-z] >|< \/[a-z]>|< [a-z]>|<\/ [a-z]>|<[a-z]><\/[a-z]>|<[a-z]>/gm;
        // for (let index = 0; index < this.katanaResult.length; index++) {
        //   const element = this.katanaResult[index];
        //   let res = element.sentence.match(regex)
        //   if (res) {
        //     if (res[0] == element.sentence.trim()) {
        //       this.katanaResult.splice(index, 1)
        //     }
        //   }
        // }

        for (let index = 0; index < this.katanaResult.length; index++) {
          this.katanaResult[index]['gec_result'] = [];
          this.katanaResHold.push(this.katanaResult[index]['sentence'])
          if (this.katanaResult[index]['sentence'].trim() == "<br>" || this.katanaResult[index]['sentence'].trim() == "</p>") {
          } else {
            this.sendSentenceToGrammerChecker(this.katanaResult[index], index)
          }
        }
        this.katanaResHold = JSON.parse(JSON.stringify(this.katanaResHold))
        this.katanaOrigResHold = JSON.parse(JSON.stringify(this.katanaResHold))
        // Remove html sentence
        //  ------??------
        // this.new_heghlightError(this.katanaResult[0], 0)
      } else {
      }
    })
  }

  // Initialise GC send request
  sendSentenceToGrammerChecker(element: katanaResult, count) {
    this.apiCallForGc(this.katanaResult[count], count)
  }

  // Recursive function for GC
  apiCallForGc(element, count) {
    if (isPlatformBrowser(this.platformId)) {

      this.errorProgressCount = this.errorProgressCount + 1;
      var holdedSentence = element['sentence'];
      this.networkServices.postRequestForGrammerChecker({
        "lang_type": this.languageSelection,
        "result": [holdedSentence],
        "pipeline": "gector_rb",
        "ukey": this.ukey,
        "email_address": this.emailAdress
      }).subscribe(result => {
        // For sort the result
        if (result != []) {
          result = result.sort(function (a, b) {
            return (a['start_index'] - b['start_index']);
          })

          result = this.elemenateErrorOfSameSpan(result);
        }
        this.katanaResult[count]['gec_result'] = [];
        if (result.length >= 0) {
          result.forEach(item => {
            item['sen_begin_index'] = element['begin']
            item['sen_end_index'] = element['end']
            item['sentence'] = element['sentence']
            item['parrentIndex'] = count
            item['isCorrected'] = false // This key for to understand this error is corrected or not
            item['isExpanded'] = false
            this.katanaResult[count]['gec_result'].push(item);
            this.gec_result.push(item)
            // }
          });
          this.gec_result = this.gec_result.sort(function (a, b) {
            return (a['parrentIndex'] - b['parrentIndex']);
          })
          if (count < this.katanaResult.length - 1) {
            // this.sendSentenceToGrammerChecker(this.katanaResult[count], count + 1)
            this.noeErrorFound = true;
            this.alertErrorMessage = "<b>No issues found.</b>"
          } else {
            if (this.gec_result.length <= 0) {
              // debugger
              this.alertErrorMessage = "<b>No issues found.</b>"
            }
            if (this.gec_result == []) {
              this.alertErrorMessage = "<b>No issues found.</b>"
            }
          }
        } else {
          // this.logger.debug("this.katanaResult", this.katanaResult)
        }
        this.new_heghlightError(this.katanaResult[count], count)
        this.errorProgressCount = this.errorProgressCount - 1;
        if (this.errorProgressCount == 0) {
          this.progressStatus(false)
        }
      })
      // this.logger.debug(this.gec_result)
    }
  }

  elemenateErrorOfSameSpan(result) {
    for (let i = 0; i < result.length; i++) {
      for (let j = 0; j < result.length; j++) {
        if (result[i].start_index < result[j].start_index && result[i].end_index > result[j].start_index) {
          result.splice(j, 1);
        } else if (result[i].start_index < result[j].end_index && result[i].end_index > result[j].end_index) {
          result.splice(j, 1);
        }
      }
    }
    return result;
  }

  tempList = [];
  // Highlight errors in editor
  new_heghlightError(obj: any, count) {
    if (isPlatformBrowser(this.platformId)) {
      // this.logger.debug(`new_heghlightError`, obj)
      var element = obj;
      if (element.gec_result.length > 0) {
        var tmp = "";
        for (let index = element.gec_result.length - 1; index >= 0; index--) {
          const errorItem = element.gec_result[index];
          if (errorItem.error_type[0] == 1) {//Grammar
            // this.logger.debug("grammer")
            tmp = element['sentence'].substring(0, element.gec_result[index].start_index) + this.grammarErrorStartHeighlight + element['sentence'].substring(element.gec_result[index].start_index, element.gec_result[index].end_index + 1) + this.grammarErrorEndHeighlight + element['sentence'].substring(element.gec_result[index].end_index + 1, element['sentence'].length);
          } else if (errorItem.error_type[0] == 2) {//Spelling
            // this.logger.debug("spelling")
            tmp = element['sentence'].substring(0, element.gec_result[index].start_index) + this.spellingErrorStartHeighlight + element['sentence'].substring(element.gec_result[index].start_index, element.gec_result[index].end_index + 1) + this.spellingErrorEndHeighlight + element['sentence'].substring(element.gec_result[index].end_index + 1, element['sentence'].length);
          } else {//Suggession
            // this.logger.debug("suggestion")
            tmp = element['sentence'].substring(0, element.gec_result[index].start_index) + this.advisorErrorStartHeighlight + element['sentence'].substring(element.gec_result[index].start_index, element.gec_result[index].end_index + 1) + this.advisorErrorEndHeighlight + element['sentence'].substring(element.gec_result[index].end_index + 1, element['sentence'].length);
          }

          element['sentence'] = tmp;
        }
        this.katanaResHold[count] = tmp;
        this.ckEditor.instance.document.getBody().$.innerHTML = this.katanaResHold.join(" ")
        // this.editorValue = this.katanaResHold.join(" ")
        this.tempList.push(tmp)
      } else {
        this.tempList.push(element.sentence)
      }
    }
  }

  // Accept changes
  error_panel_action(element, childIndex, output) {
    if (isPlatformBrowser(this.platformId)) {
      if (element.isCorrected == false) {
        if (element.error_type[0] == 1) {//Grammar
          this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.grammarErrorHeighlightActive + element.covered_text + this.grammarErrorEndHeighlight, output)
        } else if (element.error_type[0] == 2) {//Spelling
          this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.spellingErrorHeighlightActive + element.covered_text + this.spellingErrorEndHeighlight, output)
        } else {//Suggession
          this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.advisorErrorHeighlightActive + element.covered_text + this.advisorErrorEndHeighlight, output)
        }
        this.ckEditor.instance.document.getBody().$.innerHTML = this.katanaResHold.join(" ")
        this.gec_result.splice(childIndex, 1)
        if (this.gec_result.length <= 0) {
          // debugger
          this.alertErrorMessage = "Yay! You’re done here. If you want to check your text again, click Check my writing"
        }
        element['acceptedOutput'] = output
        this.acceptSuggetionsRequest(element)
        this.adjacentError(element, childIndex)
        // this.wordCountLogic();
      }
    }
  }

  adjacentError(element, childIndex) {
    if (isPlatformBrowser(this.platformId)) {

      for (let i = 0; i < this.gec_result.length; i++) {
        if (this.gec_result[i].parrentIndex == element.parrentIndex) {
          if ((element.start_index - this.gec_result[i].end_index) <= 2 && (element.start_index - this.gec_result[i].end_index) > 0) {
            this.rejectChange(this.gec_result[i], i, true)
            this.gec_result.splice(i, 1);
          }
          if ((element.end_index - this.gec_result[i].start_index) <= 2 && (element.end_index - this.gec_result[i].start_index) >= 0) {
            this.rejectChange(this.gec_result[i], i, true)
            this.gec_result.splice(i, 1);
          }
          if ((this.gec_result[i].start_index - element.end_index) <= 2 && (this.gec_result[i].start_index - element.end_index) >= 0) {
            this.rejectChange(this.gec_result[i], i, true)
            this.gec_result.splice(i, 1);
          }

        }
      }

    }
  }

  rejectChange(element, childIndex, flag) {
    if (isPlatformBrowser(this.platformId)) {

      if (element.error_type[0] == 1) {//Grammar
        // this.logger.debug("grammer")
        this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.grammarErrorStartHeighlight + element.covered_text + this.grammarErrorEndHeighlight, element.covered_text).replace(this.grammarErrorHeighlightActive + element.covered_text + this.grammarErrorEndHeighlight, element.covered_text)
      } else if (element.error_type[0] == 2) {//Spelling
        // this.logger.debug("spelling")
        this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.spellingErrorStartHeighlight + element.covered_text + this.spellingErrorEndHeighlight, element.covered_text).replace(this.spellingErrorHeighlightActive + element.covered_text + this.spellingErrorEndHeighlight, element.covered_text)
      } else {//Suggession
        // this.logger.debug("suggestion")
        this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.advisorErrorStartHeighlight + element.covered_text + this.advisorErrorEndHeighlight, element.covered_text).replace(this.advisorErrorHeighlightActive + element.covered_text + this.advisorErrorEndHeighlight, element.covered_text)
      }

      this.ckEditor.instance.document.getBody().$.innerHTML = this.katanaResHold.join(" ")
      if (!flag) {
        this.gec_result.splice(childIndex, 1)
        this.rejectSuggetionsRequest(element)
      }
      if (this.gec_result.length <= 0) {
        // debugger
        this.alertErrorMessage = "Yay! You’re done here. If you want to check your text again, click Check my writing."
      }
      // this.wordCountLogic();
    }
  }

  clearAllHighlight() {
    if (isPlatformBrowser(this.platformId)) {

      let x = /<span style="border-bottom:solid #7a6ff1;">|<\/span>|<span style="border-bottom:solid #fd9a00;">|<span style="border-bottom:solid #37c5ab;">|<span style='border-bottom:solid #7a6ff1;'>|<\/span>|<span style='border-bottom:solid #fd9a00;'>|<span style='border-bottom:solid #37c5ab;'>|<span style="border-bottom: solid #37c5ab; background-color: #37c5ab5c;">|<span style='border-bottom: solid #fd9a00; background-color: #fd9a005e;'>|<span style="border-bottom: solid #fd9a00; background-color: #fd9a005e;">|<span style='border-bottom: solid #7a6ff1; background-color: #7a6ff152'>|<span style="border-bottom: solid #7a6ff1; background-color: #7a6ff152">/g

      let z = /<span class=\"error\">/g
      this.ckEditor.instance.document.getBody().$.innerHTML = this.ckEditor.instance.document.getBody().$.innerHTML.replace(x, "")
    }
  }

  setStep(element, index) {
    if (isPlatformBrowser(this.platformId)) {

      // This is for remove previous highlight
      if (!this.prevElementHolder) {
        this.prevElementHolder = element;
      } else {
        this.prevElementHolder.isExpanded = false;

        if (this.prevElementHolder.error_type[0] == 1) {//Grammar
          this.katanaResHold[this.prevElementHolder['parrentIndex']] = this.katanaResHold[this.prevElementHolder['parrentIndex']].replace(this.grammarErrorHeighlightActive + this.prevElementHolder['covered_text'] + this.grammarErrorEndHeighlight, this.grammarErrorStartHeighlight + this.prevElementHolder['covered_text'] + this.grammarErrorEndHeighlight);

        } else if (this.prevElementHolder.error_type[0] == 2) {//Spelling

          this.katanaResHold[this.prevElementHolder['parrentIndex']] = this.katanaResHold[this.prevElementHolder['parrentIndex']].replace(this.spellingErrorHeighlightActive + this.prevElementHolder['covered_text'] + this.spellingErrorEndHeighlight, this.spellingErrorStartHeighlight + this.prevElementHolder['covered_text'] + this.spellingErrorEndHeighlight);
        } else {//Suggession
          this.katanaResHold[this.prevElementHolder['parrentIndex']] = this.katanaResHold[this.prevElementHolder['parrentIndex']].replace(this.advisorErrorHeighlightActive + this.prevElementHolder['covered_text'] + this.advisorErrorEndHeighlight, this.advisorErrorStartHeighlight + this.prevElementHolder['covered_text'] + this.advisorErrorEndHeighlight);
        }
        this.ckEditor.instance.document.getBody().$.innerHTML = this.katanaResHold.join(" ");
        // this.editorValue = this.katanaResHold.join(" ");
        this.prevElementHolder = element;
      }
      // -----------------------------------------
      // This is for highlight firsttime
      element.isExpanded = true;
      if (element.error_type[0] == 1) {//Grammar

        this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.grammarErrorStartHeighlight + element.covered_text + this.grammarErrorEndHeighlight, this.grammarErrorHeighlightActive + element.covered_text + this.grammarErrorEndHeighlight);

      } else if (element.error_type[0] == 2) {//Spelling

        this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.spellingErrorStartHeighlight + element.covered_text + this.spellingErrorEndHeighlight, this.spellingErrorHeighlightActive + element.covered_text + this.spellingErrorEndHeighlight);

      } else {//Suggession

        this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.advisorErrorStartHeighlight + element.covered_text + this.advisorErrorEndHeighlight, this.advisorErrorHeighlightActive + element.covered_text + this.advisorErrorEndHeighlight);

      }
      //---------------------------------------------
      this.ckEditor.instance.document.getBody().$.innerHTML = this.katanaResHold.join(" ");
      // this.editorValue = this.katanaResHold.join(" ");

    }
  }


  setStepOff(element, index) {
    if (isPlatformBrowser(this.platformId)) {

      // This is for highlight firsttime
      element.isExpanded = false;
      if (element.error_type[0] == 1) {//Grammar

        this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.grammarErrorHeighlightActive + element.covered_text + this.grammarErrorEndHeighlight, this.grammarErrorStartHeighlight + element.covered_text + this.grammarErrorEndHeighlight);

      } else if (element.error_type[0] == 2) {//Spelling

        this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.spellingErrorHeighlightActive + element.covered_text + this.spellingErrorEndHeighlight, this.spellingErrorStartHeighlight + element.covered_text + this.spellingErrorEndHeighlight);

      } else {//Suggession
        this.katanaResHold[element.parrentIndex] = this.katanaResHold[element.parrentIndex].replace(this.advisorErrorHeighlightActive + element.covered_text + this.advisorErrorEndHeighlight, this.advisorErrorStartHeighlight + element.covered_text + this.advisorErrorEndHeighlight);
      }
      this.ckEditor.instance.document.getBody().$.innerHTML = this.katanaResHold.join(" ");
    }
  }

  public onBlur(editor) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        } catch (error) {

        }
      }
  }

  public getBrowserName() {
    if (isPlatformBrowser(this.platformId)) {

      const agent = window.navigator.userAgent.toLowerCase()
      switch (true) {
        case agent.indexOf('edge') > -1:
          return 'edge';
        case agent.indexOf('opr') > -1 && !!(<any>window).opr:
          return 'opera';
        case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
          return 'chrome';
        case agent.indexOf('trident') > -1:
          return 'ie';
        case agent.indexOf('firefox') > -1:
          return 'firefox';
        case agent.indexOf('safari') > -1:
          return 'safari';
        default:
          return 'other';
      }
    }
  }

  clearTags() {

    if (isPlatformBrowser(this.platformId)) {

      this.tagNames.forEach((i) => {
        try {
          if (document.querySelector(i)) {
            document.querySelector(i).remove()
          }
        } catch (error) {
        }
      })
    }
  }

  handleExtension(brwName: string, target: string) {
    if (isPlatformBrowser(this.platformId)) {

      /* 
        currently browser is only required, in future target name will help specify the arrays to clear the tags array inside clearTags method
        Note - Grammarly doesn't have an extension in opera browser
      */
      const supported_browsers = ["chrome", "firefox", "safari"]
      if (supported_browsers.indexOf(brwName) != -1) {
        this.clearTags()
      }
    }
  }

  public onFocus(event?) {
    if (isPlatformBrowser(this.platformId)) {

      try {
        setTimeout(() => {
          const brwsrName = this.getBrowserName()
          this.handleExtension(brwsrName, "grammarly")
        }, 100);
      } catch (error) {
      }
    }
  }

  public outFocus(event) {
    if (isPlatformBrowser(this.platformId)) {
      try {

      } catch (error) {

      }
    }
  }

  public onMouseUp(editor) {
    if (isPlatformBrowser(this.platformId)) {
      try {

      } catch (error) {

      }
    }
  }

  public onKeyUp(event) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        if (!(this.alertErrorMessage == 'TRUE' && !this.gec_result.length)) {
          this._timeout = null;
          if (this._timeout) { //if there is already a timeout in process cancel it
            window.clearTimeout(this._timeout);
          }
          this._timeout = window.setTimeout(() => {
            this._timeout = null;
            this.gec_result = [];
            this.katanaResHold = [];
            this.katanaResult = [];
            this.katanaOrigResHold = [];
            // let editor = this.ckEditor.instance;
            // this.logger.debug(editor.editable())
            this.alertErrorMessage = "It looks like you have added new text. Please click <b>CHECK MY WRITING</b> again."


          }, 1000);
        }
      } catch (error) {

      }
    }
  }

  public onPaste(event:ClipboardEvent) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        let clipboardData = event.clipboardData;
        let pastedText = clipboardData.getData('text');
        this.sampleEditor.nativeElement.value = this.sampleEditor.nativeElement.value + pastedText;
        this.wordCountLogic(2);
        this.enableCheck = false;
        this.wordCount;
      } catch (error) {

      }
    }
  }

  public htmlEntitiesReplacer(text) {
    if (isPlatformBrowser(this.platformId)) {
    text = text.replace(/&#33;/g, "!").replace(/&#39;/g, "'").replace(/&#32;/g, " ").replace(/&#34;/g, "\"").replace(/&#35;/g, "#").replace(/&#36;/g, "$").replace(/&#37;/g, "%").replace(/&#38;/g, " &").replace(/&amp;/g, "&").replace(/&#40;/g, "(").replace(/&#41;/g, ")").replace(/&#42;/g, "*").replace(/&#43;/g, "+").replace(/&#44;/g, ",").replace(/&#45;/g, "-").replace(/&#46;/g, ".").replace(/&#47;/g, "/").replace(/&#48;/g, "0").replace(/&#49;/g, "1").replace(/&#50;/g, "2").replace(/&#51;/g, "3").replace(/&#52;/g, "4").replace(/&#53;/g, "5").replace(/&#54;/g, "6").replace(/&#55;/g, "7").replace(/&#56;/g, "8").replace(/&#57;/g, "9").replace(/&#58;/g, ":").replace(/&#59;/g, ";").replace(/&#60;/g, "<").replace(/&#61;/g, "=").replace(/&#62;/g, ">").replace(/&#63;/g, "?").replace(/&#64;/g, "@").replace(/&#65;/g, "A").replace(/&#66;/g, "B").replace(/&#67;/g, "C").replace(/&#68;/g, "D").replace(/&#69;/g, "E").replace(/&#70;/g, "F").replace(/&#71;/g, "G").replace(/&#72;/g, "H").replace(/&#73;/g, "I").replace(/&#74;/g, "J").replace(/&#75;/g, "K").replace(/&#76;/g, "L").replace(/&#77;/g, "M").replace(/&#78;/g, "N").replace(/&#79;/g, "O").replace(/&#80;/g, "P").replace(/&#81;/g, "Q").replace(/&#82;/g, "R").replace(/&#83;/g, "S").replace(/&#84;/g, "T").replace(/&#85;/g, "U").replace(/&#86;/g, "V").replace(/&#87;/g, "W").replace(/&#88;/g, "X").replace(/&#89;/g, "Y").replace(/&#90;/g, "Z").replace(/&#91;/g, "[").replace(/&#92;/g, "\\").replace(/&#93;/g, "]").replace(/&#94;/g, "^").replace(/&#95;/g, "_").replace(/&#96;/g, "`").replace(/&#97;/g, "a").replace(/&#98;/g, "b").replace(/&#99;/g, "c").replace(/&#100;/g, "d").replace(/&#101;/g, "e").replace(/&#102;/g, "f").replace(/&#103;/g, "g").replace(/&#104;/g, "h").replace(/&#105;/g, "i").replace(/&#106;/g, "j").replace(/&#107;/g, "l").replace(/&#109;/g, "m").replace(/&#110;/g, "n").replace(/&#111;/g, "o").replace(/&#112;/g, "q").replace(/&#114;/g, "r").replace(/&#115;/g, "s").replace(/&#116;/g, "t").replace(/&#117;/g, "u").replace(/&#118;/g, "v").replace(/&#119;/g, "w").replace(/&#120;/g, "y").replace(/&#122;/g, "z").replace(/&#123;/g, "{").replace(/&#124;/g, "}").replace(/&#126;/g, "~").replace("&Aacute;", "Á").replace(/&#193;/g, "Á").replace("&Agrave;", "À").replace(/&#192;/g, "À").replace("&Acirc;", "Â").replace(/&#194;/g, "Â").replace("&Atilde;", "Ã").replace(/&#195;/g, "Ã").replace("&Auml;", "Ä").replace(/&#196;/g, "Ä").replace("&Aring;", "Å").replace(/&#197;/g, "Å").replace("&AElig;", "Æ").replace(/&#198;/g, "Æ").replace("&Ccedil;", "Ç").replace(/&#199;/g, "Ç").replace("&Egrave;", "È").replace(/&#200;/g, "È").replace("&Eacute;", "É").replace(/&#201;/g, "É").replace("&Ecirc;", "Ê").replace(/&#202;/g, "Ê").replace("&Euml;", "Ë").replace(/&#203;/g, "Ë").replace("&Igrave;", "Ì").replace(/&#204;/g, "Ì").replace("&Iacute;", "Í").replace(/&#205;/g, "Í").replace("&Icirc;", "Î").replace(/&#206;/g, "Î").replace("&Iuml;", "Ï").replace(/&#207;/g, "Ï").replace("&ETH;", "Ð").replace(/&#208;/g, "Ð").replace("&Ntilde;", "Ñ").replace(/&#209;/g, "Ñ").replace("&Ograve;", "Ò").replace(/&#210;/g, "Ò").replace("&Oacute;", "Ó").replace(/&#211;/g, "Ó").replace("&Ocirc;", "Ô").replace(/&#212;/g, "Ô").replace("&Otilde;", "Õ").replace(/&#213;/g, "Õ").replace("&Ouml;", "Ö").replace(/&#214;/g, "Ö").replace("&Oslash;", "Ø").replace(/&#216;/g, "Ø").replace("&Ugrave;", "Ù").replace(/&#217;/g, "Ù").replace("&Uacute;", "Ú").replace(/&#218;/g, "Ú").replace("&Ucirc;", "Û").replace(/&#219;/g, "Û").replace("&Uuml;", "Ü").replace(/&#220;/g, "Ü").replace("&Yacute;", "Ý").replace(/&#221;/g, "Ý").replace("&THORN;", "Þ").replace(/&#222;/g, "Þ").replace("&szlig;", "ß").replace(/&#223;/g, "ß").replace("&agrave;", "à").replace(/&#224;/g, "à").replace("&aacute;", "á").replace(/&#225;/g, "á").replace("&acirc;", "â").replace(/&#226;/g, "â").replace("&atilde;", "ã").replace(/&#227;/g, "ã").replace("&auml;", "ä").replace(/&#228;/g, "ä").replace("&aring;", "å").replace(/&#229;/g, "å").replace("&aelig;", "æ").replace(/&#230;/g, "æ").replace("&ccedil;", "ç").replace(/&#231;/g, "ç").replace("&egrave;", "è").replace(/&#232;/g, "è").replace("&eacute;", "é").replace(/&#233;/g, "é").replace("&ecirc;", "ê").replace(/&#234;/g, "ê").replace("&euml;", "ë").replace(/&#235;/g, "ë").replace("&igrave;", "ì").replace(/&#236;/g, "ì").replace("&iacute;", "í").replace(/&#237;/g, "í").replace("&icirc;", "î").replace(/&#238;/g, "î").replace("&iuml;", "ï").replace(/&#239;/g, "ï").replace("&eth;", "ð").replace(/&#240;/g, "ð").replace("&ntilde;", "ñ").replace(/&#241;/g, "ñ").replace("&ograve;", "ò").replace(/&#242;/g, "ò").replace("&oacute;", "ó").replace(/&#243;/g, "ó").replace("&ocirc;", "ô").replace(/&#244;/g, "ô").replace("&otilde;", "õ").replace(/&#245;/g, "õ").replace("&ouml;", "ö").replace(/&#246;/g, "ö").replace("&oslash;", "ø").replace(/&#248;/g, "ø").replace("&ugrave;", "ù").replace(/&#249;/g, "ù").replace("&uacute;", "ú").replace(/&#250;/g, "ú").replace("&ucirc;", "û").replace(/&#251;/g, "û").replace("&uuml;", "ü").replace(/&#252;/g, "ü").replace("&yacute;", "ý").replace(/&#253;/g, "ý").replace("&thorn;", "þ").replace(/&#254;/g, "þ").replace(/&#255;/g, "ÿ").replace("&yuml;", "ÿ").replace(/&times;/g, "×").replace(/&plusmn;/g, "±").replace(/&#39;/g, "'").replace(/&nbsp;/g, " ").replace(/&minus;/g, "-").replace(/&rsquo;/g, "'")
    // .replace(/&gt;/g, ">").replace(/&lt;/g, "<")
    return text;
    }
  }

  public hideModal1():void {
    $("#acceptedLimitExhausted").removeClass('show');
  }
  showSnackBar($event: any) {
    console.log('showSnackBar ===> ', $event);
    this._snackBar.open($event, '', {
      duration: 3000
    });
  }
  editorConfig: any = {
    endpoint: environment.server_url.multilingual_server,
    lang: 'en',
    minHeight: 360,
    sessionLimit: 3
  };
  sessionExhausted($event: any) {
    console.log('limitExhausted ===> ', $event);
    this._dialog.open(DetectionLimitExhaustModalComponent, {
      backdropClass: 'custom-dialog-background',
      width: '490px',
      height: 'auto',
      scrollStrategy: new NoopScrollStrategy(),
      panelClass: "border-radius16",
    });
  }
  openFeedbackModal($event: any) {
    console.log('openFeedbackModal ===> ', $event);
    const dialogRef = this._dialog.open(FeedbackModalComponent, {
      width: '464px',
      height: 'auto',
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        feature: 'multilingual',
        language: this.editorConfig.lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
    });
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
